var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.456,
    height: 48.335,
    viewBox: "0 0 51.456 48.335",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: #004057;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke: #004057;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke-width: 1.456px;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 0.48px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconos-03",
    transform: "translate(0.729 0.728)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7627",
    "data-name": "Path 7627",
    className: "cls-1",
    d: "M29.377,42.709c-18.924,0-28.122-3.634-28.122-11.107a1.576,1.576,0,0,1,1.564-1.585,4.241,4.241,0,0,0,3.46-1.373c1.824-2.168,1.254-6.278,1.25-6.321C7.507,10.7,17.322,1.449,29.381,1.449S51.255,10.7,51.255,22.077,41.44,42.705,29.381,42.705h0ZM4.617,33.022c1.488,4.268,9.976,6.512,24.76,6.512,10.337,0,18.749-7.834,18.749-17.457S39.714,4.624,29.377,4.624s-18.749,7.83-18.749,17.453c.021,0,.795,5.335-1.977,8.625a6.787,6.787,0,0,1-4.034,2.317h0Z",
    transform: "translate(-1.255 -1.449)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7628",
    "data-name": "Path 7628",
    className: "cls-2",
    d: "M29.806,27.729a6.249,6.249,0,1,1-6.248-6.35,6.3,6.3,0,0,1,6.248,6.35Z",
    transform: "translate(10.813 13.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7629",
    "data-name": "Path 7629",
    className: "cls-2",
    d: "M19.1,27.729a6.249,6.249,0,1,1-6.248-6.35,6.3,6.3,0,0,1,6.248,6.35Z",
    transform: "translate(2.769 13.532)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7630",
    "data-name": "Path 7630",
    className: "cls-3",
    d: "M14.452,12.775a1.586,1.586,0,0,1-1.577-1.585A1.561,1.561,0,0,1,14.423,9.6h.03a1.586,1.586,0,0,1,0,3.171Z",
    transform: "translate(7.481 4.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7631",
    "data-name": "Path 7631",
    className: "cls-3",
    d: "M21.589,12.775a1.589,1.589,0,0,1-1.577-1.585A1.561,1.561,0,0,1,21.559,9.6h.034a1.586,1.586,0,0,1,0,3.171h0Z",
    transform: "translate(12.845 4.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7632",
    "data-name": "Path 7632",
    className: "cls-3",
    d: "M21.331,23.654A9.547,9.547,0,0,1,12,16.067a1.587,1.587,0,0,1,1.182-1.9,1.57,1.57,0,0,1,1.87,1.2,6.422,6.422,0,0,0,12.573,0,1.56,1.56,0,0,1,1.866-1.2,1.591,1.591,0,0,1,1.186,1.9,9.556,9.556,0,0,1-9.339,7.587h0Z",
    transform: "translate(6.791 8.085)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaze);
export default __webpack_public_path__ + "static/media/waze.5b245cc5f593bdbd9b8a0162a24adb32.svg";
export { ForwardRef as ReactComponent };